"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteApi = deleteApi;
exports.getCategoryBannerById = getCategoryBannerById;
exports.getCategoryBannerEnable = getCategoryBannerEnable;
exports.listCategoryBanner = listCategoryBanner;
exports.trendsCreateApi = trendsCreateApi;
exports.updateApi = updateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request2"));
var _qs = _interopRequireDefault(require("qs"));
/*
 * @Author: 张月平 sam.zhang@neo-digitex.com
 * @Date: 2025-07-14 16:24:15
 * @LastEditors: 张月平 sam.zhang@neo-digitex.com
 * @LastEditTime: 2025-07-15 09:17:58
 * @FilePath: \frontend\src\api\cont\customBanner.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// 获取类目banner 列表 by type
function listCategoryBanner(params) {
  return (0, _request.default)({
    url: '/cms/listCategoryBanner',
    method: 'get',
    params: params
  });
}

// 官网 获取类目banner 启用的 by type
function getCategoryBannerEnable(params) {
  return (0, _request.default)({
    url: '/cms/getCategoryBannerEnable',
    method: 'get',
    params: params
  });
}
// 通过id 获取详情类目banner
function getCategoryBannerById(params) {
  return (0, _request.default)({
    url: '/cms/page',
    method: 'get',
    params: params
  });
}

// 添加类目banner
function trendsCreateApi(data) {
  return (0, _request.default)({
    url: '/cms/addCategoryBanner',
    method: 'post',
    data: data
  });
}
// 修改类目banner
function updateApi(data) {
  return (0, _request.default)({
    url: '/cms/updateCategoryBanner',
    method: 'post',
    data: data
  });
}
// 删除类目banner
function deleteApi(data) {
  return (0, _request.default)({
    url: '/cms/deleteCategoryBanner',
    method: 'post',
    data: data
  });
}